document.addEventListener("DOMContentLoaded", function () {
  var $win = $(window);

  const getHeaderNavigation = () => {
    return document.querySelector("#HeaderNavigation [data-navigation]");
  };

  const getSidebarMenuContainer = () => {
    return (
      document.querySelector("#navigation-menu-hum [data-navigation-menu-hum]") ||
      document.querySelector("#navigation-mobile [data-navigation-mobile]")
    );
  };

  const syncSidebarMenuFromHeader = () => {
    const nav = getHeaderNavigation();
    const target = getSidebarMenuContainer();
    if (!nav || !target) return;

    const existing = target.querySelector(".header__inline-menu");
    if (existing && existing.innerHTML.trim().length) return;
    if (existing) existing.remove();

    const styleSource =
      nav.getAttribute("style") ||
      nav.closest("#HeaderNavigation")?.getAttribute("style");

    const wrapper = document.createElement("nav");
    wrapper.className = "header__inline-menu";
    wrapper.setAttribute("data-navigation", "");
    wrapper.setAttribute("role", "navigation");
    if (styleSource) wrapper.setAttribute("style", styleSource);
    wrapper.innerHTML = nav.innerHTML || "";
    target.appendChild(wrapper);

    const loading = target.querySelector(".list-menu-loading");
    if (loading) loading.remove();

    const topLanCur = document.querySelector(".top-language-currency");
    const lanCurTarget = document.querySelector("#navigation-menu-hum .nav-currency-language");
    if (lanCurTarget && topLanCur && lanCurTarget.textContent.trim() === "") {
      const holder = document.createElement("div");
      holder.className = "top-language-currency";
      holder.innerHTML = topLanCur.innerHTML;
      lanCurTarget.appendChild(holder);
    }
  };

  document.addEventListener(
    "click",
    function (e) {
      const toggle = e.target.closest(".Menu-toggle, .mobileMenu-toggle, .desktop-menu-toggle");
      if (!toggle) return;

       if ($win.width() > 1024) {
        syncSidebarMenuFromHeader();
      }
    },
    true
  );

  if (document.body.classList.contains("menu_open")) {
    if ($win.width() > 1024) {
      syncSidebarMenuFromHeader();
    }
  }

  document.body.addEventListener("click", function (e) {
    if (
      e.target.classList.contains("halo-sidebar-close") ||
      e.target.classList.contains("background-overlay")
    ) {
      document.body.classList.remove("menu_open");
    }
  });
});

/* ======================================================
      DESKTOP MEGAMENU TABS — NO REDIRECT
   ====================================================== */

// Stop redirect ONLY on desktop
$(document).on("click", ".menu-lv-1 > a, .menu-lv-1__action", function (e) {
  if ($(window).width() > 1024) {
    e.preventDefault();
    e.stopPropagation();
  }
});

// Open/Close megamenu as tabs
$(document).on("click", ".menu-lv-1 > a, .menu-lv-1__action", function (e) {
  if ($(window).width() > 1024) {
    e.preventDefault();

    let $item = $(this).closest(".menu-lv-1");
    let $dropdown = $item.find(".menu-dropdown");

    // Already open → close it
    if ($item.hasClass("is-open")) {
      $item.removeClass("is-open");
      $dropdown.removeClass("is-open").addClass("is-hidden");
      return;
    } 

    // Close all others
    $(".menu-lv-1").removeClass("is-open");
    $(".menu-dropdown").removeClass("is-open").addClass("is-hidden");

    // Open clicked
    $item.addClass("is-open");
    $dropdown.removeClass("is-hidden").addClass("is-open");
  }
});

/* ======================================================
   DESKTOP — TEXT CLICK = REDIRECT NORMAL
   ====================================================== */

$(document).on("click", ".menu-lv-1__action .text", function (e) {
  if ($(window).width() > 1024) {
    // allow redirect
    e.stopPropagation(); // do NOT close menu, ONLY text should redirect
  }
});


/* ======================================================
      MOBILE BACK BUTTON (WORKING)
   ====================================================== */

$(document).on("click", ".nav-title-mobile", function (e) {
  
    e.preventDefault();
    e.stopPropagation();

    let $parentLv1 = $(this).closest(".menu-lv-1.is-open");
    let $submenu = $parentLv1.find(".header__submenu, .menu-dropdown");

    // Hide submenu
    $submenu.removeClass("is-open").addClass("is-hidden");
    $parentLv1.removeClass("is-open");

    // Show other menu items back
    $parentLv1.siblings().removeClass("is-hidden d-none");
    $submenu.removeClass("is-open").removeClass("is-hidden");

 
});

/* ======================================================
      CLICK OUTSIDE → CLOSE DROPDOWN (DESKTOP ONLY)
   ====================================================== */
$(document).on("click", function (e) {
  if ($(window).width() > 1024) {
    if (!$(e.target).closest(".menu-lv-1, .menu-dropdown").length) {
      $(".menu-lv-1").removeClass("is-open");
      $(".menu-dropdown").removeClass("is-open").addClass("is-hidden");
    }
  }
});